// "Como aparece no app": as artes da pasta fixa "App das consultoras" dos
// Criativos, com o TÍTULO que vira o nome do cartão no app, se aparece ou não,
// e a ordem. Substitui o editor da pasta Publicidade do Storage do Tecnologia
// (desde 14/09 o app lê desta pasta, e aquele editor gravava na pasta velha).
import { useEffect, useState } from 'react'
import { FiEye, FiEyeOff, FiCheck, FiLoader, FiFolder } from 'react-icons/fi'
import { API_APP, useApp, useEnviar, Carregando, Falha, Cabeca, Chip, Selo, num, quando } from './comum'

type Arte = { arquivo: string; tipo?: 'imagem' | 'video'; pasta: string; bytes: number; em: string; titulo: string | null; titulo_padrao: string; ativo: boolean; ordem: number; url: string }

export function ArtesDoApp({ gere }: { gere: boolean }) {
  const { dados, erro, carregando, recarregar } = useApp<{ artes: Arte[] }>(`${API_APP}/artes`)
  if (!dados) return erro ? <Falha erro={erro} tentar={recarregar} /> : <Carregando />
  const visiveis = dados.artes.filter(a => a.ativo).length
  const pastas = new Set(dados.artes.map(a => a.pasta).filter(Boolean)).size

  return (
    <div className="h-full min-h-0 flex flex-col gap-3 p-4 sm:p-5">
      <Cabeca
        titulo="Como as artes aparecem no app"
        sub="Pasta “App das consultoras” dos Criativos. O título é o nome do cartão no app; escondida, a arte some do app sem apagar o arquivo."
        carregando={carregando} recarregar={recarregar}
        chips={<>
          <Chip tom="bom">{num(visiveis)} aparecendo</Chip>
          {dados.artes.length - visiveis > 0 && <Chip>{num(dados.artes.length - visiveis)} escondidas</Chip>}
          <Chip>{num(pastas)} {pastas === 1 ? 'pasta' : 'pastas'}</Chip>
          {!gere && <Chip tom="alerta">só leitura — editar pede “Criativos — enviar e organizar”</Chip>}
        </>}
      />
      <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hidden">
        {dados.artes.length === 0 ? (
          <p className="text-[12.5px] text-muted-foreground text-center py-10">Nenhuma arte (imagem ou vídeo) na pasta “App das consultoras”. Envie pela aba Criativos → Arquivos.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
            {dados.artes.map(a => <Cartao key={a.arquivo} a={a} gere={gere} aoSalvar={recarregar} />)}
          </div>
        )}
      </div>
    </div>
  )
}

function Cartao({ a, gere, aoSalvar }: { a: Arte; gere: boolean; aoSalvar: () => void }) {
  const enviar = useEnviar()
  const [titulo, setTitulo] = useState(a.titulo || '')
  const [ordem, setOrdem] = useState(String(a.ordem))
  const [ativo, setAtivo] = useState(a.ativo)
  const [estado, setEstado] = useState<'' | 'salvando' | 'salvo' | string>('')
  useEffect(() => { setTitulo(a.titulo || ''); setOrdem(String(a.ordem)); setAtivo(a.ativo) }, [a.titulo, a.ordem, a.ativo])
  const mudou = titulo !== (a.titulo || '') || ordem !== String(a.ordem) || ativo !== a.ativo

  const salvar = async (proximoAtivo = ativo) => {
    setEstado('salvando')
    const r = await enviar(`${API_APP}/artes`, { arquivo: a.arquivo, titulo, ordem: Number(ordem) || 0, ativo: proximoAtivo }, 'PUT')
    if (!r.ok) { setEstado(r.erro || 'falhou'); return }
    setEstado('salvo'); setTimeout(() => setEstado(''), 1500)
    aoSalvar()
  }

  return (
    <div className={`neu-card rounded-2xl overflow-hidden flex flex-col ${ativo ? '' : 'opacity-60'}`}>
      <div className="relative bg-muted aspect-[4/3] max-w-full">
        {a.tipo === 'video'
          ? <video src={a.url} controls preload="metadata" playsInline className="absolute inset-0 w-full h-full object-contain bg-black" />
          : <img src={a.url} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-contain" />}
        {!ativo && <span className="absolute top-2 left-2"><Selo><FiEyeOff className="w-3 h-3" />escondida no app</Selo></span>}
      </div>
      <div className="p-3 flex flex-col gap-2">
        <p className="text-[11px] text-muted-foreground truncate flex items-center gap-1" title={a.arquivo}>
          {a.pasta && <><FiFolder className="w-3 h-3 shrink-0" />{a.pasta} ·</>} {a.arquivo.split('/').pop()} · {quando(a.em)}
        </p>
        {gere ? (
          <form onSubmit={e => { e.preventDefault(); salvar() }} className="flex flex-col gap-2">
            <label className="flex flex-col gap-0.5 text-[11px]">
              <span className="text-muted-foreground">Título no app</span>
              <input value={titulo} onChange={e => setTitulo(e.target.value)} maxLength={120} placeholder={a.titulo_padrao}
                className="neu-inset rounded-lg px-2.5 py-1.5 text-[12.5px] bg-transparent outline-none" />
            </label>
            <div className="flex items-end gap-2">
              <label className="flex flex-col gap-0.5 text-[11px] w-20">
                <span className="text-muted-foreground" title="Menor aparece primeiro">Ordem</span>
                <input value={ordem} onChange={e => setOrdem(e.target.value.replace(/[^\d-]/g, '').slice(0, 4))} inputMode="numeric"
                  className="neu-inset rounded-lg px-2.5 py-1.5 text-[12.5px] bg-transparent outline-none tabular-nums" />
              </label>
              <button type="button" onClick={() => { const n = !ativo; setAtivo(n); salvar(n) }} disabled={estado === 'salvando'}
                className="neu-relief inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-medium">
                {ativo ? <><FiEyeOff className="w-3.5 h-3.5" />Esconder</> : <><FiEye className="w-3.5 h-3.5" />Mostrar</>}
              </button>
              <button type="submit" disabled={!mudou || estado === 'salvando'}
                className="ml-auto inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-semibold bg-primary text-primary-foreground disabled:opacity-40">
                {estado === 'salvando' ? <FiLoader className="w-3.5 h-3.5 animate-spin" /> : <FiCheck className="w-3.5 h-3.5" />}Salvar
              </button>
            </div>
            {estado && estado !== 'salvando' && <p className={`text-[11px] ${estado === 'salvo' ? 'text-emerald-700' : 'text-red-600'}`}>{estado === 'salvo' ? 'Salvo — já vale no app.' : estado}</p>}
          </form>
        ) : (
          <p className="text-[12.5px] font-medium">{a.titulo || a.titulo_padrao}</p>
        )}
      </div>
    </div>
  )
}
